"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _context = require("../context");

var _responsive = require("../responsive");

var _utils = require("../utils");

var _mixins = require("../mixins");

var _core = require("@emotion/core");

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  ", "\n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var popoverContainerMixins = (0, _utils.combineMixins)(_mixins.maxWidthMixin, _mixins.widthMixin);
var PopoverContainer = (0, _context.styledWithTheme)('div', {
  shouldForwardProp: (0, _utils.filterPropsFromPropTypes)(popoverContainerMixins.propTypes, {
    additionalPropsToFilter: ['padding']
  })
})(_templateObject(), function (_ref) {
  var padding = _ref.padding;
  return padding ? "padding: ".concat(padding, ";") : '';
}, popoverContainerMixins);
PopoverContainer.displayName = 'PopoverContainer';
PopoverContainer.propTypes = {
  children: _propTypes.default.node
};
PopoverContainer.defaultProps = {
  width: 'max-content'
};

var ResponsivePopoverContainer = function ResponsivePopoverContainer(props) {
  var propsMap = {
    s: 'calc(100vw - 32px)',
    default: '40vw'
  };

  var _useBreakpoints = (0, _responsive.useBreakpoints)({
    propsMap: propsMap
  }),
      maxWidth = _useBreakpoints.props;

  return (0, _core.jsx)(PopoverContainer, (0, _extends2.default)({
    maxWidth: maxWidth
  }, props));
};

var _default = ResponsivePopoverContainer;
exports.default = _default;